import { Navigate, Route, Routes } from "react-router-dom";

import { BrandIdentity } from "containers/admin/clients/client/theme-configuration-page/brand-identity/brand-identity";
import { ThemePreview } from "containers/admin/clients/client/theme-configuration-page/theme-preview/theme-preview";
import { Configuration } from "containers/admin/clients/client/theme-configuration-page/configuration/configuration";

import { Route as AppRoute } from "utilities/app-routes";

export const ThemeConfigurationRoutes = () => (
  <Routes>
    <Route path={AppRoute.brandIdentity + "/*"} element={<BrandIdentity />} />
    <Route path={AppRoute.preview + "/*"} element={<ThemePreview />} />
    <Route path={AppRoute.configuration + "/*"} element={<Configuration />} />
    <Route path="*" element={<Navigate to={AppRoute.brandIdentity} replace />} />
  </Routes>
);
